
export class PageBuilder {

    private static get context(): any {
        const pageBuilderNameSpace: any = (window as any).PB;
        return pageBuilderNameSpace;
    }

    public static get isInEditor(): boolean {
        return Boolean(this.context && this.context.$ && location.href.includes('pbEdit=true'));
    }

    public static afterInit(): Promise<void> {
        if(this.isInEditor)
        return new Promise((resolve) => {
            this.context.$(document.documentElement).one("EnteredDesignMode", () => resolve());
        });
        return Promise.resolve();
    }
}
